import { getCookie, setCookie } from './cookie'
import { v4 as uuidv4 } from 'uuid'

export const getDeviceId = () => {
  let deviceId = getCookie('deviceId')

  if (!deviceId) {
    deviceId = uuidv4()
    setCookie('deviceId', deviceId, {
      domain: 'earnin.com',
      sameSite: 'strict',
      secure: true,
      httpOnly: false,
      maxAge: 1707109200, // 400 days by default, max possible value as per https://developer.chrome.com/blog/cookie-max-age-expires/,,
    })
  }

  return deviceId
}
